import React, { useEffect } from 'react'
import { BarcodeScanningResult, CameraType } from 'expo-camera'
import { StyleProp, View, ViewStyle } from 'react-native'

import Typography from '@ui/typography'
import cn from '@ui/utils/cn'
import keyscanner from './keyscanner'
import { debugQR } from '@order/utils/getDebugLog'
const CodeScanner = ({
  className,
  style,
  onBarcodeScanned,
}: {
  onBarcodeScanned?: (result: BarcodeScanningResult) => void
  className?: string
  style?: StyleProp<ViewStyle>
  facing?: CameraType
}) => {
  useEffect(() => {
    debugQR.log('Starting QR scanner')
    const scanner = new keyscanner((res) => {
      onBarcodeScanned?.({
        data: res,
        type: 'qr',
        cornerPoints: [],
        bounds: {
          origin: { x: 0, y: 0 },
          size: { width: 0, height: 0 },
        },
      })
    })
    return scanner.stop
  }, [onBarcodeScanned])
  // TODO: We don't really use this as modal content on the web for now
  return null

  return (
    <View
      className={cn('items-center justify-center gap-16', className)}
      style={style}
    >
      <Typography variant="H4">Scan QR</Typography>
      <Typography variant="MD">Use the card reader to scan QR codes</Typography>
    </View>
  )
}

export default CodeScanner
